<template>
  <div class="d-flex align-self-center" :class="{ 'nav-menu--mobile': mobile }">
    <nav-link to="/" :title="$t('navigation_bar.dashboard')" class="mx-4" />

    <nav-link
      to="/inbetriebsetzung?page=1&journey=all&order_status=all"
      :title="$t('navigation_bar.commissioning')"
      class="mx-4"
    />

    <nav-link
      to="/baustrom?page=1"
      :title="$t('navigation_bar.event_electricity')"
      class="mx-4"
    />

    <nav-link
      to="/plombierung?page=1"
      :title="$t('navigation_bar.sealing')"
      class="mx-4"
    />

    <nav-link
      to="/netzanschluesse?page=1&journey=all&status=all&rt=all"
      :title="$t('navigation_bar.power_connection')"
      class="mx-4"
    />

    <nav-link
      to="/emobilitaet?page=1&status=all&rt=all"
      :title="$t('navigation_bar.emobility')"
      class="mx-4"
    />

    <nav-link
      to="/installateure?page=1&status=all&expiry=all&energy_type=all"
      :title="$t('navigation_bar.metrology')"
      class="mx-4"
    />

    <nav-link
      to="/verbrauchseinrichtung?page=1&status=all"
      :title="$t('navigation_bar.consumption_devices')"
      class="mx-4"
    />

    <nav-link
      to="/einspeiseanlagen?page=1&status=all&performance=all"
      :title="$t('navigation_bar.feed_in_systems')"
      class="mx-4"
    />
  </div>
</template>

<script>
import NavLink from './NavLink';

export default {
  name: 'NavMenu',
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    NavLink,
  },
};
</script>

<style scoped>
.nav-menu--mobile {
  flex-direction: column;
}

.nav-menu--mobile > div {
  margin-top: 8px;
  margin-bottom: 8px;
}
</style>
